import { JSX, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import useBreakpoints from '../../../../common/hooks/useBreakpoints';
import {
  Notification,
  NotificationType,
} from '../../../../common/widgets/Notification';
import { Toast } from '../../../../common/widgets/Toast';
import { CustomerInfoContext } from '../../contexts/CustomerInfoContext';
import { resources } from '../../resources/resources';
import Footer from '../footer';
import Header from '../header';

export default function BenefitLayout(props: { children: JSX.Element }) {
  const { isTablet } = useBreakpoints();
  const context = useContext(CustomerInfoContext);
  const { t: translate } = useTranslation();

  return (
    <>
      <Header />
      <div className="toast-wrapper">
        <Toast />
      </div>
      {context?.customerInfo?.isImpersonating && (
        <Notification
          type={NotificationType.Warning}
          controlClassName="pb-0"
          messages={[
            {
              message: translate(resources.impersonating),
            },
          ]}
        />
      )}
      {props.children}
      <Footer />
      {isTablet && <div className="mobile-nav-overlay"></div>}
    </>
  );
}
